import { QueryClient } from "@tanstack/react-query";
import { UTAH_PROGRAM_ID } from "~/participant/constants/utah.constants";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";

export async function getIsUtahParticipant(queryClient: QueryClient) {
  const user = await queryClient.ensureQueryData(USERS_QUERIES.profile());
  const isParticipant = user?.type === "participant";
  const isUtahParticipant = user?.profile?.programs?.some((program) => program.id === UTAH_PROGRAM_ID) ?? false;

  return isParticipant && isUtahParticipant;
}
